import classNames from "classnames";
import { observer } from "mobx-react";
import React, { cloneElement, ReactElement } from "react";

import Tooltip, { TooltipSize } from "../Tooltip/Tooltip";
import { observable, runInAction } from "mobx";

export interface IToolBarOption {
  value: string;
  icon: ReactElement;
  onMouseEnter?: () => void;
  onMouseLeave?: () => void;
  hint?: string;
  hintSize?: TooltipSize;
  onClick?: () => void;
  isDisabled?: (() => boolean) | boolean;
  isNonSelectable?: boolean;
}

interface IToolBarComponentProps {
  options: IToolBarOption[];
}

@observer
export default class Toolbar extends React.Component<IToolBarComponentProps> {
  @observable.ref
  private selectedValue = "";

  public render() {
    const { options } = this.props;

    return <div className="toolbar">{options.map(this.renderButton, this)}</div>;
  }

  private isDisabled = (option: IToolBarOption) => {
    if (typeof option.isDisabled === "function") {
      return option.isDisabled();
    } else {
      return option.isDisabled;
    }
  };

  private renderButton = (option: IToolBarOption): JSX.Element => {
    const buttonClassNames = classNames({
      toolbar__button: true,
      "toolbar__button--selected": option.value === this.selectedValue,
      "toolbar__button--disabled": this.isDisabled(option),
      "toolbar__button--delete": option.value === "delete",
    });

    return (
      <Tooltip key={option.value} content={option.hint || ""} size={option.hintSize}>
        <button
          onClick={this.createHandleOnClick(option)}
          onMouseEnter={option.onMouseEnter}
          onMouseLeave={option.onMouseLeave}
          onFocus={option.onMouseEnter}
          onBlur={option.onMouseLeave}
          className={buttonClassNames}
        >
          {option.icon && cloneElement(option.icon, { className: "toolbar__icon" })}
        </button>
      </Tooltip>
    );
  };

  private createHandleOnClick = (option: IToolBarOption) => {
    return () => {
      if (this.isDisabled(option)) {
        return;
      }
      if (!option.isNonSelectable) {
        runInAction(() => {
          this.selectedValue = option.value;
        });
      }
      if (option.onClick) {
        option.onClick();
      }
    };
  };
}
